export enum EventConfigurationKeys {
  Reception = 'reception',
  Schedule = 'schedule',
  MainStage = 'mainStage',
  Sessions = 'sessions',
  Posters = 'posters',
  Expo = 'expo',
  Lounge = 'lounge',
  Helpdesk = 'helpdesk',
}
